import type { Locale } from '../types';
import type { Stage } from '../../types';
import { jaStages } from './ja';
import { enStages } from './en';
import { zhStages } from './zh';
import { alignStagesWithBase } from '../../lib/stageParity';

const rawMap: Record<Locale, Stage[]> = {
  ja: jaStages,
  en: enStages,
  zh: zhStages,
};

export function getStages(locale: Locale): Stage[] {
  const raw = rawMap[locale] ?? jaStages;
  if (locale === 'ja') return raw;
  return alignStagesWithBase(raw, jaStages, locale);
}
